"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpringboardEngagementSettings = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var IconToggle_1 = require("Common/IconToggle/IconToggle");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var SpringboardEngagementSettings = (function (_super) {
    __extends(SpringboardEngagementSettings, _super);
    function SpringboardEngagementSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleEngagementMenu = function () {
            var projectStore = _this.props.projectStore;
            var enableMenu = !_this.engagementMenuEnabled;
            projectStore.setSpringboardSettings({ engagementMenuEnabled: enableMenu });
            if (!enableMenu) {
                projectStore.setSpringboardSettings({ contactPageOwnerEnabled: false });
            }
        };
        _this.toggleContactOwner = function () {
            var projectStore = _this.props.projectStore;
            projectStore.setSpringboardSettings({ contactPageOwnerEnabled: !_this.contactOwnerEnabled });
        };
        return _this;
    }
    Object.defineProperty(SpringboardEngagementSettings.prototype, "engagementMenuEnabled", {
        get: function () {
            var _a;
            return (_a = this.props.projectStore.settings.springboard) === null || _a === void 0 ? void 0 : _a.engagementMenuEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpringboardEngagementSettings.prototype, "contactOwnerEnabled", {
        get: function () {
            var _a;
            return (_a = this.props.projectStore.settings.springboard) === null || _a === void 0 ? void 0 : _a.contactPageOwnerEnabled;
        },
        enumerable: false,
        configurable: true
    });
    SpringboardEngagementSettings.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "other-settings__springboard-menu" },
                react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.SelectionType, null), label: "Springboard menu", value: this.engagementMenuEnabled, onChange: this.toggleEngagementMenu }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                    "Springboard allows your clients to stay engaged with Qwilr pages.",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/793-what-is-springboard" }, "Learn more"))),
            react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.Contact, null), label: "Page owner contact button", value: this.contactOwnerEnabled, onChange: this.toggleContactOwner, disabled: !this.engagementMenuEnabled, disabledMessage: "Enable the Springboard Menu to use this setting" })));
    };
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SpringboardEngagementSettings.prototype, "toggleEngagementMenu", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SpringboardEngagementSettings.prototype, "toggleContactOwner", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SpringboardEngagementSettings.prototype, "engagementMenuEnabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SpringboardEngagementSettings.prototype, "contactOwnerEnabled", null);
    SpringboardEngagementSettings = __decorate([
        mobx_react_1.observer
    ], SpringboardEngagementSettings);
    return SpringboardEngagementSettings;
}(react_1.default.Component));
exports.SpringboardEngagementSettings = SpringboardEngagementSettings;
